

export function validateNameCharacter(name: string): boolean {
  const regex = /^[a-zA-Z0-9_&\- ]*$/;
  return !regex.test(name);
}

export function validateNameLength(name: string, length: number): boolean {
  return name.length < length;
}

export function checknumber(value: any): boolean {
  return !isNaN(value)
}


export const validateRequired = (value: any) => {
  if (value === null || value === undefined) return true
  if (typeof value === 'string') return value.trim().length === 0
  if (Array.isArray(value)) return value.length === 0
  if (value instanceof Map || value instanceof Set) return value.size === 0
  if (typeof value === 'object') return Object.keys(value).length === 0
  return false
}

export const validateDuplicate = (dataset:any, key: any, index: number) =>{
    return dataset?.findIndex(
      (x:any, _index:any) =>x[key]?.toLowerCase().trim() === x[key]?.toLowerCase().trim() && 
        x.status?.toLowerCase() === x.status?.toLowerCase() &&
        index !== _index
    ) !== -1;
  }